export default function TrendingSection() {
  return (
    <section className="py-14 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-semibold mb-4 whitespace-nowrap">
            <i className="ri-fire-line mr-1"></i> Weekly Updates
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Trending Now
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-lg mx-auto">
            The most popular pandabuy sheet collections being explored right now.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          <a
            href="https://kaspreadsheet.com/search-914/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden aspect-[3/4] flex items-end p-5 md:p-6 cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20layer%20of%20modern%20jackets%20and%20coats%20draped%20artfully%20on%20a%20minimalist%20cream%20backdrop%20with%20soft%20directional%20studio%20lighting%20creating%20gentle%20shadows%20editorial%20fashion%20photography%20clean%20refined%20composition%20warm%20neutral%20palette&width=600&height=800&seq=trend-jackets-v2&orientation=portrait"
              alt="Trending Jackets"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              title="Pandabuy Sheet Jackets trending collection"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
            <div className="relative z-10">
              <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50">Jackets</h3>
              <p className="text-sm text-background-50/75 mt-1 max-w-xs">Top-rated outerwear from verified spreadsheets</p>
              <span className="inline-flex items-center gap-1 mt-3 text-sm font-semibold text-accent-400 whitespace-nowrap">
                Explore Now <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-915/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden aspect-[3/4] flex items-end p-5 md:p-6 cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Well%20styled%20casual%20pants%20and%20tailored%20shorts%20arranged%20on%20a%20warm%20beige%20linen%20backdrop%20soft%20natural%20window%20light%20editorial%20fashion%20photography%20clean%20minimalist%20composition%20earthy%20neutral%20tones%20modern%20aesthetic&width=600&height=800&seq=trend-pants-v2&orientation=portrait"
              alt="Trending Pants"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              title="Pandabuy Sheet Pants Shorts trending"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
            <div className="relative z-10">
              <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50">Pants / Shorts</h3>
              <p className="text-sm text-background-50/75 mt-1 max-w-xs">Best value bottoms from curated lists</p>
              <span className="inline-flex items-center gap-1 mt-3 text-sm font-semibold text-accent-400 whitespace-nowrap">
                Explore Now <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-916/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl overflow-hidden aspect-[3/4] flex items-end p-5 md:p-6 cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Curated%20collection%20of%20fashion%20headwear%20baseball%20caps%20bucket%20hats%20and%20beanies%20on%20a%20warm%20cream%20surface%20soft%20overhead%20studio%20lighting%20editorial%20photography%20clean%20composition%20neutral%20earthy%20tones&width=600&height=800&seq=trend-headwear-v2&orientation=portrait"
              alt="Trending Headwear"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              title="Pandabuy Sheet Headwear trending"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
            <div className="relative z-10">
              <h3 className="text-xl md:text-2xl font-heading font-bold text-background-50">Headwear</h3>
              <p className="text-sm text-background-50/75 mt-1 max-w-xs">Hats, caps &amp; beanies from trending lists</p>
              <span className="inline-flex items-center gap-1 mt-3 text-sm font-semibold text-accent-400 whitespace-nowrap">
                Explore Now <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}